import React, { useState, useRef, useLayoutEffect, useEffect } from 'react'
import withRipple from 'jd-library/withRipple';
import styles from './dropdown-options.scss';
import historyHandler from 'jd-library/historyHandler';

const getOptionsMarkup = (props) => {
	let drawerOptions = props.drawerOptions;
	const optionsMarkup = [];
	for(let opt in drawerOptions){
		const curOption = drawerOptions[opt];
		optionsMarkup.push(<DrawerOptionRipple key={opt} option={curOption} {...curOption} onClick={props.onClick} />);
	}
	return optionsMarkup;
};

export const toModuleClass = (classList, styles) => classList.split(' ').map((cur) => styles[cur] || cur).join(' ');

const DrawerOption = props => {

	return (
		<div
			className={toModuleClass(`edit-option ${props.rippleClass}`, styles)}
			onClick={(e) => props.onClick(e, props.option)}
			tabIndex={0}
			role="menuitem"
			onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') props.onClick(e, props.option); }}
			{...props.rippleHandler}
		>
			<i className={`${props.icon} edit-option-icon`} />
			<span className={toModuleClass(`edit-option-text`, styles)}>{props.text}</span>
			{props.renderRipple()}
		</div>
	);
};
const DrawerOptionRipple = withRipple(DrawerOption);

const UploadDropdownOptions = (props) => {
	const [style, updateStyle] = useState(props.style);
	const [arrowClass, updateArrowClass] = useState('');
	const arrowHolderRef = useRef(null);
	const previousFocusRef = useRef(null);
	const styleObj = {
		...style
	}
	useLayoutEffect(() => {
		const containerInfo = props.containerInfo;
		const {
			element,
			pos
		} = containerInfo
		let newStyleObj = {
			...style
		};
		let arrowClass = '';
		try{
			newStyleObj.pos = pos || '';
			let boundClientRect = element.getBoundingClientRect();
			// const popov
			// popover width 180
			// popover height 110
			const popoverWidth = 180;
			const popoverHeight = popoverRef.current.offsetHeight;
			console.log(boundClientRect, popoverRef.current, pos);
			if(pos === 'left'){
				// newStyleObj.top = 
				newStyleObj.left = boundClientRect.left - popoverWidth - 20;
				newStyleObj.top = boundClientRect.top - popoverHeight/2 + boundClientRect.height/2;
				newStyleObj.top -= document.body.getBoundingClientRect().top
			} else if(['top', 'bottom'].indexOf(pos) != -1){
				newStyleObj.left = boundClientRect.left - popoverWidth/2 + boundClientRect.width/2;
				let left = props.isVariant && newStyleObj.left < innerWidth - 320?innerWidth - 305:''
				newStyleObj.left = left?left:newStyleObj.left;
				if(left) {
					let arrowLeft = (boundClientRect.left - (innerWidth - 320)) + boundClientRect.width/2 - 15;;
					arrowHolderRef.current.style.setProperty('--custom-left',arrowLeft+'px');
					arrowClass = 'variant-arrow';
				}
				if(newStyleObj.left + popoverWidth > innerWidth){
					let diff = newStyleObj.left + popoverWidth - innerWidth
					arrowClass = 'adjust-right'
					if(diff > 20){
						arrowClass = 'adjust-right-ex'
					}
					delete newStyleObj.left
					newStyleObj.right = 15
				} else if(newStyleObj.left < 0){
					newStyleObj.left = 15
					arrowClass = 'adjust-left'
				}
				if(pos === 'top'){
					newStyleObj.top = boundClientRect.top - 15 - popoverHeight
					newStyleObj.top -= document.body.getBoundingClientRect().top;
					newStyleObj.pos = 'top';
					const currentTopBound = boundClientRect.bottom;
					// const outerBound = window.innerHeight + window.scrollY;
					let updatedPopHieght = window.innerWidth > popoverHeight ? window.innerWidth - popoverHeight : popoverHeight;
					if(currentTopBound > updatedPopHieght){
						newStyleObj.top = boundClientRect.top + 15 + boundClientRect.height;
						newStyleObj.top -= document.body.getBoundingClientRect().top;
						newStyleObj.pos = 'bottom';
					}
				} else{
					newStyleObj.top = boundClientRect.top + 15 + boundClientRect.height;
					newStyleObj.top -= document.body.getBoundingClientRect().top;
					newStyleObj.pos = 'bottom';
					const currentTopBound = newStyleObj.top + popoverHeight;
					const outerBound = innerHeight + scrollY;
					if(currentTopBound > outerBound){
						newStyleObj.top = boundClientRect.top - 15 - popoverHeight;
						newStyleObj.top -= document.body.getBoundingClientRect().top;
						newStyleObj.pos = 'top';
					}
				}
			}
		} catch(e){}
		updateStyle(newStyleObj);
		updateArrowClass(arrowClass);
	}, [props.style])
	const popoverRef = useRef(null);

	useEffect(() => {
		previousFocusRef.current = document.activeElement;
		const firstItem = popoverRef.current && popoverRef.current.querySelector('[role="menuitem"]');
		if (firstItem) firstItem.focus({ preventScroll: true });
		return () => {
			if (previousFocusRef.current && typeof previousFocusRef.current.focus === 'function') {
				previousFocusRef.current.focus();
			}
		};
	}, []);

	const handleMenuKeyDown = (e) => {
		if (!popoverRef.current) return;
		const items = Array.from(popoverRef.current.querySelectorAll('[role="menuitem"]'));
		const currentIndex = items.indexOf(document.activeElement);
		switch (e.key) {
			case 'Escape':
			case 'Tab':
				e.preventDefault();
				historyHandler.closeCurrent();
				break;
			case 'ArrowDown':
				e.preventDefault();
				if (items.length) items[(currentIndex + 1) % items.length].focus();
				break;
			case 'ArrowUp':
				e.preventDefault();
				if (items.length) items[(currentIndex - 1 + items.length) % items.length].focus();
				break;
			case 'Home':
				e.preventDefault();
				if (items.length) items[0].focus();
				break;
			case 'End':
				e.preventDefault();
				if (items.length) items[items.length - 1].focus();
				break;
		}
	};

	let optionsDiv = getOptionsMarkup(props);
	const handleClickOutside = (event) => {
		if (popoverRef.current && !popoverRef.current.contains(event.target)) {
			// historyHandler.closeCurrent();
		}
	  };
	 
	//   useEffect(() => {
	// 	document.addEventListener('click', handleClickOutside, true);
	// 	return () => {
	// 	  document.removeEventListener('click', handleClickOutside, true);
	// 	};
	//   }, []);

	return (
		<>
			<div
				className={toModuleClass(`popover upload-dropdown-options ${styleObj.pos}`, styles)}
				style={styleObj}
				ref={popoverRef}
				onKeyDown={handleMenuKeyDown}
			>
				<div 
					className={toModuleClass(`arrow ${arrowClass}`, styles)}
					ref={arrowHolderRef}
				>
					<div
						className={toModuleClass('full-height', styles)}
						role="menu"
						aria-label="Upload options"
					>
						{optionsDiv}
					</div>
				</div>
			</div>
			<div
				className={toModuleClass('backdrop', styles)}
				onClick={historyHandler.closeCurrent}
				aria-hidden="true"
			/>
		</>
	)
}

export default UploadDropdownOptions